import { useRef, useEffect } from "react";
import { TLCEvents } from "../events/events";

export function useEvent<TResponsePayload>(
  eventString: string,
  callback: (event: TResponsePayload) => void
) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback; // always latest

  useEffect(() => {
    const eventGuid = TLCEvents.on(eventString, (event: TResponsePayload) => {
      if (callbackRef.current) {
        callbackRef.current(event);
      }
    });
    return () => {
      TLCEvents.off(eventString, eventGuid);
    };
  }, [eventString, callback]);
}
